// extracted by mini-css-extract-plugin
export default {"root":"RootLayout_root__ZXdiS"};